module.exports = __webpack_public_path__ + "static/media/covid.88de9eb0.png";